/* @flow */
export const Experiments = {
  TEST: { // needed for Experimentation-test
    apiKey: '1080.apr.web.unit_test',
    validVariants: ['control', 'someValid'],
  },
  NEW_ACTIVITY_CREATION_FLOW: {
    apiKey: '2016.aug.web.new_activity_creation_flow',
    validVariants: ['control', 'enabled'],
  },
  ACTIVITY_CREATION_INDIVIDUAL_COMPOSER: {
    apiKey: '2016.aug.web.activity_creation_individual_composer',
    validVariants: ['control', 'enabled'],
  },
  COPPA_DIRECT_ADD: {
    apiKey: '2016.sept.web.parent_coppa',
    validVariants: ['control', 'parent_coppa'],
  },
  PROMINENT_ORG: {
    apiKey: '2016.sept.web.prominent_org',
    validVariants: ['control', 'prominent_org'],
  },
  QUICK_ACTIONS: {
    apiKey: '2016.oct.web.quick_actions',
    validVariants: ['control', 'quick_actions'],
  },
  CLASS_BADGES: {
    apiKey: '2016.nov.web.class_badges',
    validVariants: ['control', 'class_badges'],
  },
  FORCE_PHONE: {
    apiKey: '2016.dec.web.force_phone',
    validVariants: ['control', 'allow_skip', 'force_phone'],
  },
};



// WEBPACK FOOTER //
// ./src/constants/ExperimentConstants.js